import { useContext, useEffect, useRef, useState } from 'react';
// eslint-disable-next-line no-unused-vars
import Styled from 'styled-components/macro';
import { useLocation } from 'react-router-dom';
import { AuthContext } from 'context/authContext';
import { SideNavContext } from 'context/sideNavContext';
import { PerformanceFiltersContext } from 'context/performanceFiltersContext';
import {
  ArrowHolder,
  CategorySubFilterItem,
  CategorySubFilterMenu,
  CheckboxLabel,
  Li,
  RadioLabel,
  StyledLink,
  StyledSubMenu,
  SubMenuFilterItem,
  SubMenuItem,
  SubMenuLink,
  SubMenuTitle,
  Title,
} from './SideNav.styles';

function SubMenu({ item, showSubNav, subnav, showFilterSubMenu, filterSubMenu, isLoading }) {
  const { sideNavState } = useContext(SideNavContext);
  const location = useLocation();
  const ref = useRef(null);
  const subMenuLinkRef = useRef(null);
  const { setFilterValue } = useContext(PerformanceFiltersContext);
  const [checked, setChecked] = useState();

  const { allowedPages } = useContext(AuthContext);
  const activeCurrentPath =
    (location.pathname.split('/brand/')[1].includes('/') &&
      location.pathname.split('/brand/')[1].includes(item.file)) ||
    (!location.pathname.split('/brand/')[1].includes('/') && location.pathname.split('/brand/')[1] === item.file)
      ? item.id
      : false;

  useEffect(() => {
    if (activeCurrentPath === item.id) {
      ref?.current?.parentElement?.childNodes.forEach(node => {
        node.classList.remove('prev-item-active');
        node.classList.remove('next-item-active');
      });

      ref?.current?.previousElementSibling?.classList?.add('prev-item-active');
      ref?.current?.nextElementSibling?.classList?.add('next-item-active');
    }
  }, [location?.pathname]);

  return (
    <Li
      css={isLoading && 'text-align: center;'}
      ref={ref}
      className={`${item.title ? 'title' : ''} ${activeCurrentPath ? 'item-active' : ''}`}>
      {isLoading ? (
        'loading...'
      ) : (
        <StyledLink
          to={item.hideSelf ? `/brand/${item.file}/${item?.subNav[0]?.file}` : `/brand/${item.file}`}
          onClick={() => showSubNav(item.id)}>
          <i className={`icon ${item.materialIcon ? `material-icons-outlined` : `icon-${item.icon}`}`}>
            {item.materialIcon ? item.icon : ''}
          </i>
          <Title>{item.name}</Title>

          {item.subNav && subnav[item.id] ? (
            <ArrowHolder css={!sideNavState && `display:none`}>
              <span className="material-icons-outlined">expand_less</span>
            </ArrowHolder>
          ) : item.subNav ? (
            <ArrowHolder css={!sideNavState && `display:none`}>
              <span className="material-icons-outlined">expand_more</span>
            </ArrowHolder>
          ) : null}
        </StyledLink>
      )}
      {subnav[item.id] && item?.subNav && (
        <StyledSubMenu hide={!sideNavState}>
          {item?.subNav
            ?.filter(({ file }) => allowedPages.includes(file))
            .map((subNavItem, index) => (
              <SubMenuItem key={index}>
                <SubMenuLink ref={subMenuLinkRef} to={`/brand/${item?.file}/${subNavItem?.file}`}>
                  <i className="icon material-icons-outlined">{subNavItem.icon}</i>
                  <SubMenuTitle>{subNavItem.name}</SubMenuTitle>
                </SubMenuLink>
              </SubMenuItem>
            ))}
        </StyledSubMenu>
      )}
      {subnav[item.id] && item?.pr_filters && (
        <StyledSubMenu hide={!sideNavState} filterMenu>
          {item?.pr_filters.map((filtersItem, index) => (
            <SubMenuFilterItem key={index}>
              <RadioLabel
                onChange={() => {
                  showFilterSubMenu(filtersItem?.id);
                }}>
                <input type="checkbox" />
                <span className="fake-label">{filtersItem.name}</span>
                <span className="fake-radio" />
                <ArrowHolder css={!sideNavState && `display:none`}>
                  <span className="material-icons-outlined">expand_more</span>
                </ArrowHolder>
              </RadioLabel>

              {filterSubMenu[filtersItem?.id] && filtersItem?.category_subfilter && (
                <CategorySubFilterMenu>
                  {filtersItem?.category_subfilter.map(catSubFilterItem => (
                    <CategorySubFilterItem key={catSubFilterItem.id}>
                      <CheckboxLabel>
                        <input
                          value={catSubFilterItem?.name}
                          checked={checked === catSubFilterItem?.name}
                          type="checkbox"
                          onChange={e => {
                            setChecked(e.target.value);
                            setFilterValue({ name: filtersItem?.name, value: catSubFilterItem?.name });
                          }}
                        />
                        <span className="fake-label">{catSubFilterItem.name}</span>
                        <span className="fake-checkbox" />
                      </CheckboxLabel>
                    </CategorySubFilterItem>
                  ))}
                </CategorySubFilterMenu>
              )}
            </SubMenuFilterItem>
          ))}
        </StyledSubMenu>
      )}
    </Li>
  );
}

export default SubMenu;
